// extracted by mini-css-extract-plugin
export default {"rowData":"styles_rowData__mszKg"};